export default "__VITE_ASSET__BumuIFjw__"